export function shouldSucceedWithProbability(probability: number) {
  return probability >= Math.random();
}
